import { Country as WizeCountry } from '@wize-mobile-api';
import { Country } from '@qvs/core';

export class CountryMapper {
  public static fromWizeCountry = (wizeCountry: WizeCountry): Country | undefined => {
    if (!wizeCountry) {
      return undefined;
    }
    const { id, isoIdentification, description, ranking, riskCategory, ...country } = wizeCountry;
    const countryId = {
      id
    };
    const countryLabel = {
      label: description
    };
    const countryPriority = {
      priority: ranking
    };
    return { ...country, ...countryId, ...countryLabel, ...countryPriority };
  };

  public static fromWizeCountries = (countries: WizeCountry[]): Country[] =>
    countries.map((country) => CountryMapper.fromWizeCountry(country));
}
